import React from "react";
import { Form } from "react-bootstrap";
import { Col } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FilterationBarContainer from "../../../components/FilterationBarContainer";

function FilterationBar(props) {
	const {
		months,
		selectedMonth,
		years,
		selectedYear,
		status,
		selectedStatus,
		scoreList,
		selectedScore,
	} = props;
	return (
		<FilterationBarContainer>
			<Col sm={6} md={6} lg={6} xs={12} className="mb-1">
				<Form.Group className="input-field">
					<Form.Label className="label pr-1 mr-sm-0 pr-sm-0">
						Year
					</Form.Label>
					<Col xs={10} className="ml-3">
						<CustomReactSelect
							options={years}
							value={selectedYear}
							onChange={(value) => props.onYearChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>

			<Col sm={6} md={6} lg={6} xs={12} className="mb-1">
				<Form.Group className="input-field">
					<Form.Label className="label">Month</Form.Label>
					<Col xs={10}>
						<CustomReactSelect
							options={months}
							value={selectedMonth}
							onChange={(value) => props.onMonthChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>

			<Col sm={6} md={6} lg={6} xs={12} className="mt-2">
				<Form.Group className="input-field">
					<Form.Label className="label">Status</Form.Label>
					<Col xs={10}>
						<CustomReactSelect
							options={status}
							value={selectedStatus}
							onChange={(value) => props.onStatusChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>

			<Col sm={6} md={6} lg={6} xs={12} className="mt-2">
				<Form.Group className="input-field">
					<Form.Label className="label">Score</Form.Label>
					<Col xs={10}>
						<CustomReactSelect
							options={scoreList}
							value={selectedScore}
							onChange={(value) => props.onScoreChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>
		</FilterationBarContainer>
	);
}

export default FilterationBar;
